import { Component, model, input, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { MultiSelect } from 'primeng/multiselect';
import { LineItemModel } from '../../../../models/template.model';
import { SpeechService } from '../../../../services/speech.service';
import { ValidationService } from '../../../../services/validation.service';

@Component({
  selector: 'app-select-control',
  standalone: true,
  imports: [CommonModule, FormsModule, Select, MultiSelect],
  template: `
    <div class="checklist-control-row">
      <label [for]="'select-' + lineItem().lineItemId" class="checklist-control-label">
        {{ lineItem().name }}@if (lineItem().isRequired) { <span class="required-indicator">*</span>}
      </label>
      <div class="checklist-control-input">
        @if (multiple()) {
          <p-multiselect
            [inputId]="'select-' + lineItem().lineItemId"
            [options]="options()"
            [(ngModel)]="value"
            [disabled]="disabled()"
            [invalid]="hasError()"
            placeholder="Select options..."
            optionLabel="valueText"
            optionValue="valueText"
            filterBy="valueText"
            styleClass="w-full"
            appendTo="body"
            display="chip"
            [showToggleAll]="false"
            [filter]="true"
            (onBlur)="onBlur()"
          />
        } @else {
          <p-select
            [inputId]="'select-' + lineItem().lineItemId"
            [options]="options()"
            [(ngModel)]="value"
            [disabled]="disabled()"
            [invalid]="hasError()"
            placeholder="Select an option..."
            optionLabel="valueText"
            optionValue="valueText"
            filterBy="valueText"
            styleClass="w-full"
            appendTo="body"
            (onBlur)="onBlur()"
          />
        }
        @if (hasError()) {
          @for (err of errors(); track $index) {
            <small class="p-error d-block">{{ err }}</small>
          }
        } @else if (hint()) {
          <small class="text-color-secondary">{{ hint() }}</small>
        }
      </div>
      <div class="ctrl-speaker-col">
        <button type="button" class="ctrl-speaker-btn" (click)="speakLabel()"
          [attr.aria-label]="'Read label: ' + lineItem().name">
          <i class="ri-volume-up-line"></i>
        </button>
      </div>
    </div>
  `,
  styles: []
})
export class SelectControlComponent {
  lineItem = input.required<LineItemModel>();
  value = model<any>('');
  disabled = input<boolean>(false);
  showError = input<boolean>(false);
  multiple = input<boolean>(false);

  // Transform lineItemOptionValueList to dropdown options
  options = input.required<{ valueText: string }[]>();

  private speechService = inject(SpeechService);
  private validationService = inject(ValidationService);
  touched = signal(false);

  errors = computed(() => {
    if (!this.showError() && !this.touched()) return [];
    return this.validationService.validate(this.lineItem(), this.value());
  });

  hasError = computed(() => this.errors().length > 0);
  hint = computed(() => this.hasError() ? '' : this.validationService.getHint(this.lineItem()));

  onBlur(): void {
    this.touched.set(true);
  }

  speakLabel(): void {
    this.speechService.speak(this.lineItem().name);
  }
}
